import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMalaria.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Select from "../../../../../../../components/select/Select";
import Input from "../../../../../../../components/textbox/Input";
import OggettiUtili from "../../../../../../../utils/OggettiUtili";
import SelectAutocomplete from "../../../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../../utils/Ruoli";


class DatiSegnalazioneMalaria extends React.Component {

    state = {
        datiSegnalazione: {
            tipologia: "",
            nome: "",
            recapito: "",
            ulss: "",
            distretto: "",
            data: ""
        },
        listaTipologia: [],
        listaUlss: [],
        listaDistretti: []
    }

    constructor(props) {
        super(props)

        this.state.datiSegnalazione.data = Utils.transformTimeStampForFrontend(this.props.segnalazioneCopia.timestampCompilazione)
        this.riceviValore = this.riceviValore.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this)

    }

    componentDidMount() {
        let datiSegnalazione = this.state.datiSegnalazione

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiSegnalazioneMalaria) {
            let datiSegnalazioneProps = this.props.segnalazioneCopia.schedaSpeciale.datiSegnalazioneMalaria
            datiSegnalazione.tipologia = datiSegnalazioneProps.tipologia ? datiSegnalazioneProps.tipologia : this.state.datiSegnalazione.tipologia
            datiSegnalazione.nome = datiSegnalazioneProps.nome ? datiSegnalazioneProps.nome : this.state.datiSegnalazione.nome
            datiSegnalazione.recapito = datiSegnalazioneProps.recapito ? datiSegnalazioneProps.recapito : this.state.datiSegnalazione.recapito
            datiSegnalazione.ulss = datiSegnalazioneProps.ulss ? datiSegnalazioneProps.ulss : this.state.datiSegnalazione.ulss
            datiSegnalazione.distretto = datiSegnalazioneProps.distretto ? datiSegnalazioneProps.distretto : this.state.datiSegnalazione.distretto
            datiSegnalazione.data = datiSegnalazioneProps.data ? datiSegnalazioneProps.data : this.state.datiSegnalazione.data

            this.setState({datiSegnalazione: datiSegnalazione});
            let oggetto = this.createOggettoBE()
            this.props.setSegnalazioneMalaria(this.state.datiSegnalazione, oggetto);

        } else {
            datiSegnalazione.ulss = this.props.segnalazioneCopia && this.props.segnalazioneCopia.ulssSegnalazione? this.props.segnalazioneCopia.ulssSegnalazione: ""
            this.setState({datiSegnalazione: datiSegnalazione});
            let oggetto = this.createOggettoBE()
            this.props.setSegnalazioneMalaria(this.state.datiSegnalazione, oggetto);
        }

    }


    createOggettoBE() {
        let datiSegnalazione = JSON.parse(JSON.stringify(this.state.datiSegnalazione))
        let datiSegnalazioneBe = Utils.removeEmptyValueFromObject(datiSegnalazione)
        // return Utils.removeFieldFromObject(datiSegnalazioneBe,"corretto")
        return datiSegnalazioneBe;
    }

    riceviValore(field, event) {

        let dataSegnalazione = this.state.datiSegnalazione

        if (field.currentTarget) {
            dataSegnalazione[field.currentTarget.id] = field.currentTarget.value
        } else {
            dataSegnalazione[field] = event.target.value
        }
        this.setState({datiSegnalazione: dataSegnalazione})
        let oggetto = this.createOggettoBE()
        this.props.setSegnalazioneMalaria(this.state.datiSegnalazione, oggetto)
    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 mt-1">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.tipologia")}
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Select
                                        style={{width: "100%"}}
                                        field={"tipologia"}
                                        value={this.state.datiSegnalazione.tipologia}
                                        onChange={this.riceviValore}
                                        id={"tipologia"}
                                        functionMap={Utils.mapToArray(OggettiUtili.TipologiaMalaria).map((oggetto) => {
                                            return (
                                                <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}

                                    >
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7  mt-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.nomeCompilatore")}
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Input id={"nome"}
    onChange={this.riceviValore}
    field={"nome"}
    value={this.state.datiSegnalazione.nome}
    placeholder={t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.nomeCompilatore")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className="col-lg-7">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.recapito")}
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Input id={"recapito"}
    onChange={this.riceviValore}
    field={"recapito"}
    value={this.state.datiSegnalazione.recapito}
    placeholder={t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.recapito")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{paddingTop: "1rem"}}>
                        <div className="col-lg-7">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.ulss")}
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <div className={stylesWelcome.fieldContainer}>
                                        <SelectAutocomplete
                                            id={"ulss"}
                                            field={"ulss"}
                                            disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Regionale.descrizione}
                                            value={this.state.datiSegnalazione.ulss}
                                            onChange={this.riceviValore}
                                            functionMap={Utils.mapToArray(OggettiUtili.ulssMap).map((oggetto) => {
                                                return (
                                                    <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}
                                        >
                                        </SelectAutocomplete>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "15px"}}>
                        <div className="col-lg-7 mt-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.distretto")}
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Select
                                        field={"distretto"}
                                        value={this.state.datiSegnalazione.distretto}
                                        onChange={this.riceviValore}
                                        id={"distretto"}
                                        functionMap={Utils.mapToArray(OggettiUtili.Distretti).map((oggetto) => {
                                            return (
                                                <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}

                                    >
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7 mt-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.data")}
                                    </p>
                                </div>
                                <div className="col-lg-6">
                                    <Calendar
                                        id={"data"}
                                        value={this.state.datiSegnalazione.data}
                                        field={"data"}
                                        onChange={this.riceviValore}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.DatiSegnalazione.data"))}
                                        error={(this.state.datiSegnalazione.data === "" || this.state.datiSegnalazione.data == null) ? false :
                                            Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiSegnalazione.data), "-")
                                        }

                                    >
                                    </Calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                {sezione1}
            </div>

        )
    }

}

export default withTranslation('common')(DatiSegnalazioneMalaria)
